/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from "@emotion/core";
import { ModalDismissButton } from "./modal";
import VisuallyHidden from "@reach/visually-hidden";
import CircleButton from "./CircleButton";
import { FC } from "react";
import * as colors from "styles/colors";

import { FaSpinner } from "react-icons/fa";

import { keyframes } from "@emotion/core";
import styled from "@emotion/styled/macro";
import { useLocation, useHistory } from "react-router-dom";

type CircleDismissButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const CircleDismissButton: FC<CircleDismissButtonProps> = (props) => (
  <div css={{ display: "flex", justifyContent: "flex-end", direction: "ltr" }}>
    <ModalDismissButton>
      <CircleButton {...props}>
        <VisuallyHidden>بستن</VisuallyHidden>
        <span aria-hidden>×</span>
      </CircleButton>
    </ModalDismissButton>
  </div>
);

const spin = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
});

const Spinner = styled(FaSpinner)({
  animation: `${spin} 1s linear infinite`,
});

function FullPageSpinner() {
  return (
    <div
      css={{
        fontSize: "4em",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spinner />
    </div>
  );
}

function useQueryId() {
  const { search } = useLocation();
  const { go } = useHistory();
  const query = new URLSearchParams(search);

  const idQuery = query.get("id");

  if (idQuery === null) {
    go(-1);
    return "";
  }

  return idQuery;
}

function useOptionalQueryId() {
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const idQuery = query.get("id");

  return idQuery;
}

const Active = () => (
  <span css={{ backgroundColor: colors.green100, color: colors.green800 }}>
    فعال
  </span>
);

const InActive = () => (
  <span css={{ backgroundColor: colors.red100, color: colors.red800 }}>
    غیرفعال
  </span>
);

export {
  CircleDismissButton,
  Spinner,
  FullPageSpinner,
  Active,
  InActive,
  useQueryId,
  useOptionalQueryId,
};
